<span id="total-size-container">
  <span
    >{{ totalSize.size | fileSize: 0 : true }} of
    {{ totalAllowedSize | fileSize: 0 : true }} Used</span
  >
</span>
